<template>
  <div class="play-container">
    <top-bar :user="this.user" />
    <Menu :user="this.user" :menuSelected="{ manageGames: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ manageGames: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <div>
          <!-- userul este marketing -->
          <div class="account-title ">
            <h1>{{ $t("cmsLang.pendingGamesTitle") }}
              <a @click="addModifyGame(null)" class="button-all button-yellow">
                <img src="@/assets/images/cms-mkt/plus.svg" />
                {{ $t('cmsLang.addGameLabel') }}

              </a>
              &nbsp;&nbsp;&nbsp;
              <a @click="downloadPartnersFile()" class="button-all button-blue">
                {{ $t("cmsLang.managePartnerLabel") }}
              </a>
            </h1>
            <br />
          </div>

          <div class="d-flex flex-wrap">
            <div v-if="this.pendingGames === null || this.pendingGames === undefined
              ">
              <div class="loading">
                <!-- <img src="@/assets/images/cms-mkt/loading.gif" /> -->
              </div>
            </div>
            <!-- <div v-else v-for="(offer, index) in submittedGames" :key="index" class="content-delivery"> -->
            <game-case v-else v-for="(entry, index) in pendingGames" :key="index" :game="entry" :user="user"
              :editable="true" @edit="addModifyGame" @approve="addModifyGame" @delete="addModifyGame"
              @showdetails="showDetails" />
          </div>
        </div>
        <br />
        <div>
          <div class="account-title ">
            <h1>{{ $t("cmsLang.submittedGamesTitle") }} </h1>
            <br />
          </div>

          <div class="d-flex flex-wrap">
            <div v-if="this.submittedGames === null || this.submittedGames === undefined
              ">
              <div class="loading">
                <img src="@/assets/images/cms-mkt/loading.gif" />
              </div>
            </div>
            <game-case v-else v-for="(entry, index) in submittedGames" :key="index" :game="entry" :user="user"
              :editable="false" @showdetails="showDetails" />
          </div>

        </div>

      </div>
    </div>

    <!-- <div id="modal_popup_game_type" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_game_type', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <br />
        <div class="form-check mr-2 align-baseline d radioButtonCustom">
          <label v-for="(type, index) in gameTypes" :key="index" @click="addModifyGame(null, type)">
            <input name="gameType" class="radioButtonCustom" type="radio" :value="type" v-model="selectedGameType">
            {{ $t("cmsLang.gameType_" + type) }}</label>
        </div>
      </div>
    </div> -->
    <game-popup  :game="this.selectedGame" :user="this.user" :categories="this.categories"
      @updatelist="getAllSubmittedGames" @showinfo="showPopupInfo" />
    <game-details-popup :game="this.selectedGame" :user="this.user" @edit="addModifyGame" @approve="addModifyGame"
      @delete="addModifyGame" />
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <div v-if="this.error">
          <p v-for="(entry, index) in this.error" :key="index">{{ entry.description ? entry.description : $t('cmsLang.errorMessage_' + entry) }}</p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t(this.successMessage) }}</p>
        </div>
      </div>
    </div>

    <!-- <modal-loading /> -->
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
    <!-- <PartnersPopup :user="this.user" @showinfo="showPopupInfo" /> -->

  </div>
</template>

<script>
import Menu from "@/components/cms-mkt/Menu.vue";
import TopBar from "@/components/cms-mkt/TopBar.vue";
import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-play.js";
import GameCase from "@/components/fragments/cms-mkt/GameCase.vue";
import GamePopup from "@/components/fragments/cms-mkt/NewGamePopup.vue";
import GameDetailsPopup from "@/components/fragments/cms-mkt/GameDetailsPopup.vue";
import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";
// import PartnersPopup from "@/components/fragments/cms-mkt/ManagePartnerPopup.vue";
import utils from "@/plugins/utils.js";

// import ModalLoading from "@/components/fragments/cms-mkt/ModalLoading.vue";

export default {
  name: "manageGames",

  components: {
    // ModalLoading,
    GamePopup,
    GameDetailsPopup,
    TopBar,
    GameCase,
    Menu,
    ResetPassword,
    // PartnersPopup
  },
  data() {
    return {
      user: null,
      // gameTypes: ["N", "Y"],
      gameTypes: ["N"],
      filter: {
        type: "OFFER",
        person: null
      },
      selectedGameType: "",
      sortBy: ["NEW", "OLD"],
      sortBySelected: "NEW",
      sortField: "m.misid",
      sortDirection: "desc",
      submittedGames: null,
      pendingGames: null,
      error: null,
      perPage: 10000,
      deleteSuccess: false,
      selectedGame: null,
      selectedGames: [],
      successMessage: "",
      isLoading: false,
      action: '',
      categories: null

    };
  },
  methods: {
    addModifyGame(game, label) {
      this.selectedGameType = "";
      this.action = "edit"
      this.error = null;
      this.showModalPopup("modal_popup_game_details", false);
      this.selectedGame = null;
      if (!game) {
        // if (!label) {
        //   this.showModalPopup("modal_popup_game_type", true);
        //   return;
        // } else {
          this.selectedGameType = "N";
          this.selectedGame = {
            mission_id: 0,
            group_mission: this.selectedGameType
          };
          // this.showModalPopup("modal_popup_game_type", false);
          this.showModalPopup("modal_popup_game", true);
        // }
      } else {
        this.getGameDetails(game.mission_id);
      }
    },
    showDetails(game) {
      this.action = "details";
      this.getGameDetails(game.mission_id);
    },
    getAllSubmittedGames() {
      this.getSubmittedGames(false);
      this.getSubmittedGames(true);
    },
    showPopupInfo(successMessage, error) {
      this.selectedGameType = "";
      this.successMessage = successMessage;
      this.error = error;
      // this.showModalPopup("modal_popup_partners", false);
      this.showModalPopup("modal_popup_game", false);
      this.showModalPopup("modal_popup_loading_cms", false);
      this.showModalPopup("modal_popup_info", true);
    },
    getSubmittedGames(pending) {
      this.selectedGameType = "";
      this.selectedGames = [];
      this.submittedGames = null;
      var offersData = "?type=M";
      if (pending) {
        // offersData += "&status=NEW";
        offersData += "&status=N,I";
      } else {
        offersData += "&status=A,S";
      }
      offersData +=
        "&per_page=" +
        this.perPage +
        "&page=1" +
        "&sort=" +
        this.sortDirection;
      if (this.sortDirection === "desc") {
        offersData += "&desc=" + this.sortField;
      } else {
        offersData += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchGames(offersData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = {
            code: error.response.data,
            description: error.response.data,
          };
        })
        .then((response) => {
          if (response.status == 200) {
            if (pending) {
              this.pendingGames = response.data;
            } else {
              this.submittedGames = response.data;
            }
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.error = {
              code: response.data,
              description: response.data,
            };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = { description: response.description };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          }
        });
    },
    getCategories() {

      this.categories = [];
      httpServiceCustomer.customerService
        .getCategories("?lang=ro", Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
        })
        .then((response) => {
          if (response.status == 200) {
            this.categories = response.data;
          }
        });
    },
    sortByChanged(event) {
      this.sortBySelected = event.target.value;
      switch (this.sortBySelected) {
        case "NEW":
          this.sortField = "valstdate";
          this.sortDirection = "desc";
          break;
        case "OLD":
          this.sortField = "valstdate";
          this.sortDirection = "asc";
          break;
        default:
          this.sortField = "valstdate";
          this.sortDirection = "desc";
      }
      this.getSubmittedGames(false);
    },
    selectFilterType(entry) {
      this.filter.type = entry;
      this.getSubmittedGames();

    },
    getGameDetails(gameId) {
      this.showModalPopup("modal_popup_loading_cms", true);
      this.selectedGame = {};

      httpServiceCustomer.customerService
        .getGameDetails(gameId, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.selectedGame = response.data;

            this.showModalPopup("modal_popup_loading_cms", false);

            switch (this.action) {
              case "edit":
                this.showModalPopup("modal_popup_game", true);
                break;
              case "details":
                this.showModalPopup("modal_popup_game_details", true);
                break;
            }
          } else {
            this.error = {
              code: response.data.code,
            };
          }
        })
        .catch((error) => {
          this.error = { code: error.response.code };
          this.showModalPopup("modal_popup_loading_cms", false);
        });
    },
    showManagePartnerList() {
      this.error = null;
      this.showModalPopup("modal_popup_partners", true);
    },
    downloadPartnersFile() {
      this.showModalPopup("modal_popup_loading_cms", true);
      httpServiceCustomer.customerService
        .getPartnersListFile(
          Cookies.get("token")
        )
        .then(function (response) {
          return response;
        })
        .catch(() => {
          this.showModalPopup("modal_popup_loading_cms", false);
        })
        .then((response) => {
          if (response.status == 200) {
            var blob = new Blob(
              [utils.base64ToArrayBuffer(response.data.content)],
              {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
              }
            );
            saveAs(blob, response.data.name);
          } else if (response.status == 400 || response.status == 403) {
          }
          this.showModalPopup("modal_popup_loading_cms", false);

        });
    },
  },
  mounted() {
    this.getAllSubmittedGames();
  },
  computed: {},
  created() {
    this.getCategories()
    this.user = this.getUser();

  },
};
</script>

<style scoped src="@/assets/styles/mkt-cms.css" />
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style src="@/assets/styles/multiselect.css" />

<style scoped>
.right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.left {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.left small {
  padding-right: 10px;
}

.left .status_11 {
  color: #FF0000;
}

.left .status_10 {
  color: #7ea800;
}

.left .status_12 {
  color: #FF0000;
}

.left .status_13 {
  color: #3C4645;
}

.content-delivery {
  flex-direction: column;
  margin-bottom: 20px;
}

.content-delivery .personimg {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 20px;
}

.offer_header {
  width: 100%;
  border-bottom: 1px solid #dcdee3;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.offer_details {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.offer_details .image {
  max-width: 80px;
  max-height: 80px;
  margin: 10px;
  padding: 30px;
}

.offer_details .imageDiv {
  /* height: 128px;
  width: 128px !important;
  margin: 10px; */
  border-radius: 100%;
  border: 1px solid #dcdee3;
  margin: 10px;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-red {
  border: 1px solid #FF0000;
  border-radius: 100px !important;
}

.multiselect {
  width: 50% !important;
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;

}

.margin-y-10 {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
